





































































































import { Component, Vue } from "vue-property-decorator";
import { Company, Employee } from "@/api";
import * as roleUtils from "@/common/role_utils";
import EditPopUpTextField from "./popUpForm/EditPopUpTextField.vue";
import { checkSelfRole } from "@/common/role_utils";

@Component({
  components: {
    EditPopUpTextField,
  },
  props: {
    onMenuClicked: {
      type: Function,
    },
  },
})
export default class AppBarMain extends Vue {
  hoverCompany = false;
  editDialog = false;
  counter = 0;
  loading = false;
  formValue = "";

  get selfInfo(): Employee {
    return this.$store.getters["getCurrentEmployeeSelf"];
  }
  get isSuperAdmin(): Employee {
    return this.$store.getters["isSuperAdmin"];
  }

  get company() {
    const comp = this.$store.getters["getSelectedCompany"] as Company;
    this.formValue = comp.name;
    return comp;
  }

  get totalAnnouncement() {
    return this.$store.getters["announcement/totalAnnouncement"];
  }

  get unreadCount() {
    const count = this.$store.getters["chat/count"];
    return count?.count || 0;
  }

  isRole(role: string) {
    return checkSelfRole(role);
  }

  showSelfProfile() {
    this.$router.push({
      path: `/company-directory/profile/${this.selfInfo.id}`,
    });
  }

  toggleDrawer() {
    this.$store.dispatch("toggleNavRail");
  }

  toggleAnnouncementDrawer() {
    this.$store.dispatch("announcement/toggleAnnouncementTab");
  }

  goTo(path: string) {
    this.$router.push({ path });
  }

  get isAdmin() {
    return roleUtils.isAdmin();
  }

  async editCompany(editCompany: Company) {
    this.loading = true;
    await this.$store.dispatch("updateCompanyCore", editCompany);
    this.loading = false;
    this.editDialog = false;
    this.counter++;
  }
}
